module.exports = __webpack_public_path__ + "static/images/ic_bee_flying_left.5ab90d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ic_bee_flying_left.png
// module id = 1257
// module chunks = 0